import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useEffect, useMemo } from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import {
  UiPreferencesProvider,
  useUiPreferences,
} from "./contexts/UiPreferencesContext";
import router from "./routes";
import authService from "./services/auth";
import { createAppTheme } from "./theme/createAppTheme";

function ThemedApp({ children }) {
  const { resolvedMode } = useUiPreferences();
  const theme = useMemo(() => createAppTheme(resolvedMode), [resolvedMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}

function App() {
  useEffect(() => {
    const atualizarPerfilUsuario = async () => {
      if (authService.isAuthenticated()) {
        try {
          await authService.atualizarPerfil();
        } catch (error) {
          console.error("Erro ao atualizar perfil:", error);
        }
      }
    };

    atualizarPerfilUsuario();
  }, []);

  return (
    <UiPreferencesProvider>
      <ThemedApp>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ThemedApp>
    </UiPreferencesProvider>
  );
}

export default App;
